import React from 'react';
import styles from './styles.module.css';
import MealItemRow from './MealItemRow';

/**
 * Uma refeição na linha do tempo do plano: horário à esquerda, ponto no
 * trilho vertical e, à direita, o cartão com nome, observação e itens.
 * Só leitura: é a visão "como o paciente vê".
 */
const MealCard = ({ meal }) => (
  <div className={styles.mealRow}>
    <span className={meal.time ? styles.mealTime : `${styles.mealTime} ${styles.mealTimeEmpty}`}>
      {meal.time || '–'}
    </span>
    <div className={styles.mealTrack} aria-hidden="true">
      <span className={styles.mealDot} />
    </div>
    <div className={styles.meal}>
      <span className={styles.mealName}>{meal.name}</span>
      {meal.note && <span className={styles.mealNote}>{meal.note}</span>}
      {meal.items && meal.items.length > 0 ? (
        <ul className={styles.items}>
          {meal.items.map((item) => <MealItemRow key={item.key} item={item} />)}
        </ul>
      ) : (
        <span className={styles.emptyMeal}>Sem itens nesta refeição.</span>
      )}
    </div>
  </div>
);

export default MealCard;
